import React from 'react';
import GlobalProps from '../globalProps';
import classnames from 'classnames';

import './ProgressBar.css';
interface Props extends GlobalProps {
  progress: number;
  size?: 'small' | 'big';
  baseColor?: string;
  barColor?: string;
  rounded?: boolean;
}

export const ProgressBar = ({ progress, size, baseColor, barColor, className, style, rounded }: Props): JSX.Element => {
  return (
    <div
      className={classnames('progress-bar', className, {
        'progress-bar--big': size === 'big',
      })}
      style={style}
    >
      <div
        className={classnames('progress-bar__base', {
          'progress-bar__base--rounded': rounded,
        })}
        style={{
          backgroundColor: baseColor,
        }}
      />
      <div
        className={classnames('progress-bar__bar', {
          'progress-bar__bar--rounded': rounded,
        })}
        style={{
          width: `${progress * 100}%`,
          backgroundColor: barColor,
        }}
      />
    </div>
  );
};
